import { SeriesLineStyle } from '../../model/types';

export const LINE_STYLE_DASH_ARRAY: Record<
  SeriesLineStyle,
  string | undefined
> = {
  [SeriesLineStyle.solid]: undefined,
  [SeriesLineStyle.dashed]: '5 5',
  [SeriesLineStyle.dotted]: '1 4',
};

export const LINE_STYLE_PATTERN: Record<SeriesLineStyle, string> = {
  [SeriesLineStyle.solid]: '—',
  [SeriesLineStyle.dashed]: '- -',
  [SeriesLineStyle.dotted]: '· ·',
};

export const TABLEAU_20_COLORS = [
  '#4E79A7',
  '#F28E2B',
  '#59A14F',
  '#B6992D',
  '#499894',
  '#E15759',
  '#79706E',
  '#D37295',
  '#B07AA1',
  '#9D7660',
  '#A0CBE8',
  '#FFBE7D',
  '#8CD17D',
  '#F1CE63',
  '#86BCB6',
  '#FF9D9A',
  '#BAB0AC',
  '#FABFD2',
  '#D4A6C8',
  '#D7B5A6',
] as const;

export const GRID_STROKE_COLOR = '#E7E9EF';

export const Y_AXIS_TICK_COUNT = 8;

export const MIN_METRIC_LINE_WIDTH = 1.5;
export const MAX_METRIC_LINE_WIDTH = 5.5;

export const LABEL_COLLISION_RATIO = 0.035;

export const AREA_FILL_OPACITY = 0.15;
export const DIMMED_SERIES_OPACITY = 0.15;

export const VALUE_LABEL_FONT_SIZE = 11;
export const VALUE_LABEL_OFFSET = 8;
export const VALUE_LABEL_DOT_RADIUS = 3;

export const VALUE_LABEL_DIFF_FONT_SIZE = 10;
export const VALUE_LABEL_DIFF_LINE_HEIGHT = 11;
export const VALUE_LABEL_DIFF_OPACITY = 0.85;

// Heuristic: compares a Y-domain fraction, not pixels — valid only at one plot height.
export const LABEL_COLLISION_RATIO_WITH_DIFF = 0.07;
